module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('i', [_vm._v("The")]), _c('br'), _vm._v("Plausibility"), _c('br'), _c('i', [_vm._v("of")]), _vm._v(" Life")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('i', [_vm._v("Resolving Darwin’s Dilemma")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('b', [_vm._v("Marc W. Kirschner and John C. Gerhart")]), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Illustrated by John Norton"), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Yale University Press      New Haven and London")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080ae8ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/01_title.vue
// module id = 60
// module chunks = 0